/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Login_Discord_SignupInputs */



/**
* | output |
* | --- |
* | "Sign Up with Discord" |
*
* @param {Login_Discord_SignupInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const login_discord_signup = /** @type {((inputs?: Login_Discord_SignupInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Login_Discord_SignupInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("S'inscrire avec Discord")
	if (locale === "es") return /** @type {LocalizedString} */ ("Registrarse con Discord")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Cadastrar com Discord")
	if (locale === "it") return /** @type {LocalizedString} */ ("Registrati con Discord")
	return /** @type {LocalizedString} */ ("Sign Up with Discord")
});